/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const CreateGroupResponse = zod.object({
  group: zod.object({
    groupActorUuid: zod.uuid(),
    parentGroupActorUuid: zod.uuid().nullable(),
  }),
});

export type CreateGroupResponse = zod.input<typeof CreateGroupResponse>;
export type CreateGroupResponseOutput = zod.output<typeof CreateGroupResponse>;
